<!-- <form autocomplete="off" (ngSubmit)="addFilterClick(filterForm)" id="filterForm" #filterForm="ngForm"> -->
<div class="modal-wrapper">
  <div class="overlay" *ngIf="showLoader">
    <app-spinner></app-spinner>
  </div>
  <div class="add-filter-header modal-header">
    <h4 class="modal-title" id="modal-basic-title">Keyword Lists</h4>
    <button type="button" class="close" aria-label="Close" (click)="close()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body ey-add-filter-body">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <p-tabView styleClass="add-keyword-tabs">
            <p-tabPanel>
              <ng-template pTemplate="header"> Predefined List ({{ selectedPredefinedCount }}) </ng-template>
              <ng-template pTemplate="content">
                <!-- <div class="row">
                      <div class="col-10">
                        <div class="form-group" [ngClass]="{'has-error': !keywordInvalid}">
                          <span class="ey-float-label">
                            <input type="text" class="form-control" id="addKeyword" name="addKeyword"
                              [(ngModel)]="keywordInput"
                              [disabled]="readOnly" #addKeyword
                              maxlength="255" required appLabelFloat />
                            <label for="addKeyword">Add New Keyword</label>
                          </span>
                          <span class="help-block" *ngIf="!keywordInvalid">
                            Please enter a Keyword
                          </span>
                        </div>
                      </div>
                      <div class="col-2">
                        <button class="btn btn-default add-button" (click)="addKeyword">Add</button>
                      </div>
                    </div> -->
                <div class="row">
                  <div class="col-12">
                    <div class="row category-row" *ngFor="let category of _keywordExtractionService?.functionCategories">
                      <div class="col-12">
                        <div class="row">
                          <div class="col-8">
                            <div class="category-heading">{{ category.category }}</div>
                          </div>
                          <div class="col-4">
                            <span class="select-all-button" (click)="selectAll(category)">Select All</span>
                          </div>
                        </div>
                        <div class="row category-keywords-row">
                          <div class="col-4 keyphrase" *ngFor="let keyphrase of predefinedList[category.functionCategoryId]">
                            <p-checkbox
                              [(ngModel)]="keyphrase.selected"
                              (onChange)="selectChanged(keyphrase)"
                              [hidden]="keyphrase['disabled']"
                              [disabled]="readOnly || keyphrase['disabled']"
                              binary="true"
                            ></p-checkbox>
                            {{ keyphrase.keyword }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-template>
            </p-tabPanel>
            <p-tabPanel>
              <ng-template pTemplate="header"> Extracted List ({{ selectedExtractedCount }}) </ng-template>
              <ng-template pTemplate="content">
                <div class="row" *ngIf="extractionInProgress">
                  <div class="p-4 text-center">{{ extractionInProgressMsg }}</div>
                </div>
                <div class="row">
                  <div class="col-10">
                    <div class="form-group" [ngClass]="{ 'has-error': keywordInvalid }">
                      <span class="ey-float-label">
                        <input
                          type="text"
                          class="form-control"
                          id="addKeyword"
                          name="addKeyword"
                          [(ngModel)]="keywordInput"
                          [disabled]="readOnly"
                          #addKeyword="ngModel"
                          maxlength="255"
                          required
                          appLabelFloat
                        />
                        <label for="addKeyword">Add New Keyword</label>
                      </span>
                      <span class="help-block" *ngIf="keywordInvalid"> Please enter a Keyword </span>
                    </div>
                  </div>
                  <div class="col-2">
                    <button class="btn btn-default add-button" [disabled]="!keywordInput" (click)="addCustomKeyword()">Add</button>
                  </div>
                </div>
                <div class="row" style="margin: -16px">
                  <!-- <div class="col-4 keyphrase" *ngFor="let keyphrase of keywordExtractionService?.extractedKeywords">
                        <p-checkbox [(ngModel)]="keyphrase.selected" (onChange)="selectChanged(keyphrase)" [disabled]="readOnly"
                          binary="true"></p-checkbox>
                        {{keyphrase.keyword}}
                      </div> -->
                  <app-extracted-keyword-list
                    style="padding: 0"
                    #keywordList
                    [keywordExtractionService]="keywordExtractionService"
                    [keywordsChanged]="keywordsChanged"
                    [readOnly]="readOnly"
                    (keywordSelected)="onKeywordSelected($event)"
                  ></app-extracted-keyword-list>
                </div>
              </ng-template>
            </p-tabPanel>
          </p-tabView>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer ey-add-filter-footer">
    <button type="button" class="btn btn-default" (click)="close()">Cancel</button>
    <button type="button" class="btn btn-primary" [disabled]="readOnly" (click)="addToList()">Add Keywords</button>
  </div>
</div>
<!-- </form> -->
